import React, { Component } from 'react';

import getContrastYIQ from '../../utils/getContrastYIQ';
import flatten from 'lodash/flatten';


const filestackThumbnail = (imageUrl, transformation = 'resize=w:160,h:160,fit:crop') => (
  imageUrl && imageUrl.match('filestackcontent.com') ? imageUrl.replace(/(\/\w+\/?)$/, `/${transformation}$1`) : imageUrl
)

const filestackCompress = (imageUrl) => filestackThumbnail(imageUrl, 'pjpg=q:80/no_metadata/cache=expiry:max/compress=m:true');

class Theme extends Component {
  
  componentWillReceiveProps (nextProps){
    if (nextProps.theme === this.props.theme)
      return
    
    const { theme } = nextProps;
    
    document.body.classList.remove(`theme-${this.props.theme}`);
    document.body.classList.add(`theme-${theme}`);
  }
  
  componentDidMount (){
    document.body.classList.add(`theme-${this.props.theme}`);
  }
  
  componentWillUnmount (){
    document.body.classList.remove(`theme-${this.props.theme}`);
  }
  
  render () {
    const style = this.props.style || {};
    
    let background = flatten([style.background]);
    const backgroundImage = (style.backgroundImage || '').match(/http/i) && filestackCompress(style.backgroundImage);
    
    let backgroundCSS = background[0];
    if ( backgroundImage ){
      background[0] = "#000000";
      backgroundCSS = `url(${backgroundImage}) ${background[0]}`;
    }
    else if ( style.backgroundGradient ){
      backgroundCSS = `linear-gradient(${style.backgroundAngle || 180}deg, ${background[0]} 0%, ${background[1] || background[0]} 100%)`;
    }
    let textColor = getContrastYIQ(background[0] || '#FFFFFF');
    
    const buttonBg = style.buttonsColor || getContrastYIQ(background[0] || '#FFFFFF');
    const buttonTextColor = getContrastYIQ(buttonBg);
    
    const serviceColor = textColor === '#000000' ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.5)';
    
    let css = `
.theme-custom{
  background: ${backgroundCSS};
  background-size: cover;
  background-position: center 50%;
}
${backgroundImage ? `
.theme-custom::before{
  content: "";
  background-color: ${background[0]};
  opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -1;   
}
` : ''}


.theme-custom .smartpage-container,
.theme-custom .smartpage-container .bio-title,
.theme-custom .smartpage-container h1,
.theme-custom .smartpage-container h2,
.theme-custom .smartpage-container h3,
.theme-custom .smartpage-container h4{
  color: ${textColor};
}

.theme-custom .smartpage-container .powered-by-shorby .shorby-logo:before {
  border-color: ${textColor};
}

.theme-custom .smartpage-container .block-item.layout-button {
  background: ${buttonBg};
  color: ${buttonTextColor};
}

.theme-custom .smartpage-container .add-block-button,
.theme-custom .smartpage-container .avatar.empty,
.theme-custom .smartpage-container .avatar-editor .avatar-upload {
  color: ${serviceColor};
  border-color: ${serviceColor};
}


.theme-custom .smartpage-container .bio-title h1.empty span{
  border-color: ${textColor};
}

.theme-custom .smartpage-container .service-button{
  background: ${serviceColor};
  color: ${getContrastYIQ(textColor)};
}`;
  
    return <style type="text/css" dangerouslySetInnerHTML={{ __html: css }} />
  }
};

export default Theme;


// WEBPACK FOOTER //
// ./src/components/SmartPages/Theme.js